<template>
  <div class="full-height center-flex">
    <h2 class="ui icon header">
      <img
        class="ui img"
        src="../../assets/img/nav/Owal O Dark@2x.png"
      >
      <div class="content">
        {{ name }}
      </div>
    </h2>
  </div>
</template>

<script>
export default {
  name: 'Placeholder',
  computed: {
    name () {
      return this.$route.name
    },
  },
}
</script>

<style scoped>
  .center-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
